module.exports = __webpack_public_path__ + "static/media/spinner3.cf806952.gif";